import { Box, Button, Icon, Portal, Tooltip, Fade } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { FiPlus as AddIcon } from "react-icons/fi";

import { useCard, useUpgradeCard } from "../../../../hooks";

export function AddEntryOrUpgradeCardButton() {
  const { hasReachedMaxEntries, handleAddEntry, card } = useCard();
  const { handleUpgradeCard, handleCloseUpgradeCardModal } = useUpgradeCard();
  const [showFixedButton, setShowFixedButton] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => {
      handleCloseUpgradeCardModal();
    };
  }, []);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        setShowFixedButton(!entry.isIntersecting);
      },
      { threshold: 0.01 }
    );
    const currentButtonRef = buttonRef.current;
    if (currentButtonRef) {
      observer.observe(currentButtonRef);
    }
    return () => {
      if (currentButtonRef) observer.unobserve(currentButtonRef);
      observer.disconnect();
    };
  }, []);

  const addEntryButton: React.ReactElement = (
    <Button
      py={["7", "10"]}
      px={["7", "10"]}
      fontSize={["18px", "24px"]}
      shadow="lg"
      variant="solid"
      isDisabled={!!card?.isLocked}
      colorScheme="green"
      leftIcon={<Icon as={AddIcon} boxSize={[6, 8]} />}
      rounded="full"
      onClick={hasReachedMaxEntries ? handleUpgradeCard : handleAddEntry}
    >
      Add entry
    </Button>
  );

  const renderedButton = card?.isLocked ? (
    <Tooltip
      label="The Cardoly has been locked. To add to it, please ask the creator to unlock it."
      placement="top-start"
    >
      {addEntryButton}
    </Tooltip>
  ) : (
    addEntryButton
  );

  return (
    <>
      {/* Add entry button at top */}
      <Box ref={buttonRef}>{renderedButton}</Box>

      {/* Add entry button at bottom. Fades in when the button at the top is no longer in view */}
      <Portal>
        <Fade in={showFixedButton} unmountOnExit>
          <Box position="fixed" right={"lg"} bottom={"lg"}>
            {renderedButton}
          </Box>
        </Fade>
      </Portal>
    </>
  );
}
